/**
 * POP API Client
 *
 * API functions for Personal Development Plans (POP).
 * Story 6-5
 */

import { apiRequest } from './api';

export interface PopProgressEntry {
  id: number;
  popId: number;
  authorId: number;
  authorName: string;
  content: string;
  progressDate: string;
  createdAt: string;
}

export interface PersonalDevelopmentPlan {
  id: number;
  employeeId: number;
  content: string;
  lastUpdatedBy: number;
  lastUpdatedByName: string;
  createdAt: string;
  updatedAt: string;
  progressEntries: PopProgressEntry[];
}

export interface UpdatePopInput {
  content: string;
}

export interface CreateProgressEntryInput {
  content: string;
  progressDate?: string;
}

export const popApi = {
  /**
   * Get POP for employee
   */
  async getPopForEmployee(employeeId: number): Promise<PersonalDevelopmentPlan> {
    return apiRequest<PersonalDevelopmentPlan>(`/pop/${employeeId}`);
  },

  /**
   * Create or update POP content
   */
  async updatePop(employeeId: number, input: UpdatePopInput): Promise<PersonalDevelopmentPlan> {
    return apiRequest<PersonalDevelopmentPlan>(`/pop/${employeeId}`, {
      method: 'PUT',
      body: JSON.stringify(input),
    });
  },

  /**
   * Add progress entry
   */
  async addProgressEntry(
    employeeId: number,
    input: CreateProgressEntryInput
  ): Promise<PopProgressEntry> {
    return apiRequest<PopProgressEntry>(`/pop/${employeeId}/progress`, {
      method: 'POST',
      body: JSON.stringify(input),
    });
  },

  /**
   * Delete progress entry
   */
  async deleteProgressEntry(employeeId: number, progressId: number): Promise<void> {
    await apiRequest(`/pop/${employeeId}/progress/${progressId}`, {
      method: 'DELETE',
    });
  },
};
